<div class="flex justify-between items-center mb-2 max-w-7xl mx-auto px-8">
    <div>
      <h1 class="text-2xl font-bold text-gray-800">Cadastro de Produtos</h1>
    </div>
    @if (isEditMode) {
      <p-button
        type="button"
        pTooltip="Duplicar produto"
        icon="pi pi-copy"
        label="Duplicar"
        [text]="true"
        severity="secondary"
        (onClick)="duplicateCurrent()">
      </p-button>
    }
  </div>

<div class="rounded-xl shadow-md p-8 max-w-7xl mx-auto">
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
    <p-tabs value="0">
      <p-tablist>
        <div class="flex justify-between w-full">
        <div class="flex items-center justify-between">
          <p-tab value="0"><i class="pi pi-box"></i>Ínicio</p-tab>
          <p-tab value="1"><i class="pi pi-shop"></i>Detalhes</p-tab>
          <!-- <p-tab value="2"><i class="pi pi-tags"></i>Atacarejo</p-tab> -->
        </div>
        <div class="flex items-center ml-4">
          <p-checkbox 
            formControlName="active"
            binary="true"
            inputId="cbActive">
          </p-checkbox>
          <label for="cbActive" class="ml-2">Ativo</label>
        </div>
      </div>
      </p-tablist>
      
      <p-tabpanels>
      <p-tabpanel value="0">  
        <div class="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <label class="block mb-1 font-medium">Código do Produto</label>
            <input
              #productCodeInput
              pInputText
              formControlName="code"
              placeholder="Digite o código"
              class="w-full"
            />
          </div>

          <div class="flex gap-3 items-end">
            <div class="flex-1 min-w-0">
              <label class="block mb-1 font-medium">Código de Barras</label>
              <input
                pInputText
                formControlName="barCode"
                placeholder="Digite o Código de Barras"
                class="w-full"
                (keydown.enter)="onBarCodeEnter($event)"
              />
            </div>
            <p-button type="button" (onClick)="generateRandomBarCode()" [rounded]="true" [text]="true">
              <i class="pi pi-qrcode"></i>
            </p-button>
          </div>


          <div class="md:col-span-2">
            <label class="block mb-1 font-medium">Descrição do Produto <span class="text-red-500">*</span></label>
            <input
              pInputText
              formControlName="description"
              placeholder="Digite a Descrição"
              class="w-full"
            />
          </div>
        </div>

        <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">

          

          <div class="flex gap-3 items-end">
            <div class="flex-1 min-w-0">
            <label class="block mb-1 font-medium">Unidade de Medida</label>
            <p-select
              formControlName="measureUnityId"
              [options]="unitsMeasures"
              optionLabel="description"
              placeholder="Selecione uma unidade"
              optionValue="id"
              [showClear]="true"
              class="w-full"
              styleClass="w-full"
            ></p-select>
            </div>
            
            <p-button (onClick)="changeModal('uniteMeasure')"><i class="pi pi-plus"></i></p-button>
          </div>

          <div class="flex gap-3 items-end">
            <div class="flex-1 min-w-0">
              <label class="block mb-1 font-medium">Setor</label>
              <p-select
                formControlName="sectorId"
                [options]="sectors"
                optionLabel="description"
                optionValue="id"
                placeholder="Opcional"
                [showClear]="true"
                class="w-full"
                styleClass="w-full"
                (onChange)="onSectorChange()"
              ></p-select>
            </div>
            <p-button (onClick)="changeModal('sector')"><i class="pi pi-plus"></i></p-button>
          </div>
          
          <div class="flex gap-3 items-end">
            <div class="flex-1 min-w-0">
            <label class="block mb-1 font-medium">Grupo</label>
            
              <p-select
                formControlName="groupId"
                [options]="groups"
                optionLabel="description"
                optionValue="id"
                placeholder="Selecione um grupo"
                [showClear]="true"
                class="w-full"
                styleClass="w-full"
                (onChange)="onGroupChange()"
              >
              </p-select>
            
            </div>

            <p-button (onClick)="changeModal('group')"><i class="pi pi-plus"></i></p-button>

          </div>

          <div class="flex gap-3 items-end">
            <div class="flex-1 min-w-0">
              <label class="block mb-1 font-medium">Subgrupo</label>
              <p-select
                formControlName="subgroupId"
                [options]="subgroups"
                optionLabel="description"
                optionValue="id"
                placeholder="Opcional"
                [showClear]="true"
                class="w-full"
                styleClass="w-full"
                [disabled]="!form.get('groupId')?.value"
              ></p-select>
            </div>
            <p-button (onClick)="changeModal('subgroup')" [disabled]="!form.get('groupId')?.value"
              ><i class="pi pi-plus"></i
            ></p-button>
          </div>

          <div class="flex gap-3 items-end">
            <div class="flex-1 min-w-0">
              <label class="block mb-1 font-medium">Família</label>
              <p-select
                formControlName="familyId"
                [options]="families"
                optionLabel="description"
                optionValue="id"
                placeholder="Opcional"
                [showClear]="true"
                class="w-full"
                styleClass="w-full"
              ></p-select>
            </div>
            <p-button (onClick)="changeModal('family')"><i class="pi pi-plus"></i></p-button>
          </div>

          <div>
            <label class="block mb-1 font-medium">Estoque Mínimo</label>
            
            <p-inputNumber
              locale="pt-BR"
              mode="decimal"
              [minFractionDigits]="0"
              [maxFractionDigits]="3"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              formControlName="minimumStock"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Estoque Atual</label>
            <p-inputNumber
              locale="pt-BR"
              mode="decimal"
              [minFractionDigits]="0"
              [maxFractionDigits]="3"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              formControlName="currentStock"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Custos operacionais</label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              formControlName="custosOperacionais"
              class="w-full"
            />
          </div>

        </div>



        <div class="grid mt-4 grid-cols-1 md:grid-cols-6 gap-6">
          <div>
            <label class="block mb-1 font-medium">Cashback</label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              formControlName="cashBack"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Limite Desconto</label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              formControlName="discountLimit"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Comissão</label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              (onFocus)="selectInputContent($event)"
              formControlName="comission"
              placeholder="Digite a Comissão"
              [inputStyle]="{ width: '100%' }"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Validade</label>
            <p-datepicker formControlName="validAt" />
          </div>
          <div>
            <label class="block mb-1 font-medium">Código Balança</label>
            <input
              pInputText
              formControlName="balanceCode"
              placeholder="Digite o código"
              class="w-full"
            />
          </div>
          <div>
            <label class="block mb-1 font-medium">Preço Custo</label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              (onBlur)="calculateProfit('priceCost')"
              formControlName="priceCost"
              class="w-full"
            />
          </div>
        </div>

        <div class="grid mt-4 grid-cols-1 md:grid-cols-6 gap-6">
          <div>
            <label class="block mb-1 font-medium">Lucro % (Venda)</label>
            <p-inputNumber
              formControlName="profitSelling"
              mode="decimal" 
              (onFocus)="selectInputContent($event)"
              (onBlur)="calculateProfit('profitSelling')"
              [minFractionDigits]="2" 
              [maxFractionDigits]="2" 
              [inputStyle]="{ width: '100%' }"
              class="w-full" />
          </div>

          <div>
            <label class="block mb-1 font-medium">Preço Venda <span class="text-red-500">*</span></label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [inputStyle]="{ width: '100%' }"
              formControlName="priceSelling"
              (onFocus)="selectInputContent($event)"
              (onBlur)="calculateProfit('priceSelling')"
              class="w-full"
            />
          </div>
          <div>
            <label class="block mb-1 font-medium">Lucro % (Prazo)</label>
            <p-inputNumber
              formControlName="profitTerm"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              (onBlur)="calculateProfit('profitTerm')"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Preço Prazo</label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              (onBlur)="calculateProfit('priceTerm')"
              formControlName="priceTerm"
              class="w-full"
            />
          </div>

          <div>
            <label class="block mb-1 font-medium">Lucro % (Atacado)</label>
            <p-inputNumber
              formControlName="profitWholeSale"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="2"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              (onBlur)="calculateProfit('profitWholeSale')"
              class="w-full"
            />
          </div>
          <div>
            <label class="block mb-1 font-medium">Preço Atacado</label>
            <p-inputNumber
              currency="BRL"
              locale="pt-BR"
              mode="currency"
              [inputStyle]="{ width: '100%' }"
              (onFocus)="selectInputContent($event)"
              (onBlur)="calculateProfit('priceWholeSale')"
              formControlName="priceWholeSale"
              class="w-full"
            />
          </div>

        </div>

    <!-- Descrição -->
    <!-- <div>
      <label class="block mb-1 font-medium">Descrição</label>
      <textarea
        pTextarea
        formControlName="description"
        rows="4"
        placeholder="Digite a descrição do produto"
        class="w-full"
      ></textarea>
    </div> -->

    <!-- Preço, Estoque, Status -->
    <!-- <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
      <div>
        <label class="block mb-1 font-medium">Preço (R$)</label>
        <input
          pInputText
          type="number"
          formControlName="priceSelling"
          class="w-full"
        />
      </div>
      <div>
        <label class="block mb-1 font-medium">Estoque</label>
        <input
          pInputText
          type="number"
          formControlName="stock"
          class="w-full"
        />
      </div> -->
      <!-- <div>
        <label class="block mb-1 font-medium">Status</label>
        <p-select
          formControlName="status"
          [options]="statusOptions"
          placeholder="Selecione o status"
          class="w-full"
        ></p-select>
      </div> -->
    <!-- </div> -->
        </p-tabpanel>
        <p-tabpanel value="1">
            <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
              <div class="flex gap-3 items-end">
                <div>
                <label class="block mb-1 font-medium">Marca</label>
                
                <div class="p-fluid">
                  <p-select
                  formControlName="brandId"
                  [options]="brands"
                  optionLabel="description"
                  optionValue="id"
                  placeholder="Selecione uma marca"
                  class="w-full"
                ></p-select>
                </div>
                
              </div>
              
                <p-button (onClick)="changeModal('brand')"><i class="pi pi-plus"></i></p-button>
              </div>

              <div class="md:col-span-3">
                <label class="block mb-1 font-medium">Localização Física</label>
                <input
                  pInputText
                  formControlName="localization"
                  class="w-full"
                />
              </div>
            </div>

            <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
              <div>
                <label class="block mb-1 font-medium md:col-span-3">Peso(KG)</label>
                <p-inputNumber
                  currency="BRL"
                  locale="pt-BR"
                  mode="currency"
                  [inputStyle]="{ width: '100%' }"
                  (onFocus)="selectInputContent($event)"
                  formControlName="weight"
                  class="w-full"
                />
              </div>

              <div>
                <label class="block mb-1 font-medium">Altura(KG)</label>
                <p-inputNumber
                  currency="BRL"
                  locale="pt-BR"
                  mode="currency"
                  [inputStyle]="{ width: '100%' }"
                  (onFocus)="selectInputContent($event)"
                  formControlName="height"
                  class="w-full"
                />
              </div>

              <div>
                <label class="block mb-1 font-medium md:col-span-3">Largura(KG)</label>
                <p-inputNumber
                  currency="BRL"
                  locale="pt-BR"
                  mode="currency"
                  [inputStyle]="{ width: '100%' }"
                  (onFocus)="selectInputContent($event)"
                  formControlName="height"
                  class="w-full"
                />
              </div>

              <div>
                <label class="block mb-1 font-medium md:col-span-3">Comprimento(KG)</label>
                <p-inputNumber
                  currency="BRL"
                  locale="pt-BR"
                  mode="currency"
                  [inputStyle]="{ width: '100%' }"
                  (onFocus)="selectInputContent($event)"
                  formControlName="height"
                  class="w-full"
                />
              </div>
            </div>

            <!-- <div  class=" mt-4">
              <label class="block mb-1 font-medium">Especificação</label>
              <p-textarea
                formControlName="especification"
                rows="4"
                placeholder="Digite a especificação"
                class="w-full"
              ></p-textarea>
            </div> -->

        </p-tabpanel>
        <p-tabpanel value="2">
            <div class="grid mt-4 grid-cols-1 md:grid-cols-4 gap-6">
              
              <div class="md:col-span-2">
                <label class="block mb-1 font-medium">Descrição</label>
                <input
                  pInputText
                  formControlName="localization"
                  class="w-full"
                />
              </div>
              

              <div>
                <label class="block mb-1 font-medium md:col-span-3">Quantidade Mínima</label>
                <p-inputNumber
                  currency="BRL"
                  locale="pt-BR"
                  mode="currency"
                  [inputStyle]="{ width: '100%' }"
                  (onFocus)="selectInputContent($event)"
                  formControlName="weight"
                  class="w-full"
                />
              </div>
               
              <div class="flex items-end">
                <div>
                  <label class="block mb-1 font-medium md:col-span-3">Valor Atacado </label>
                  <p-inputNumber
                    currency="BRL"
                    locale="pt-BR"
                    mode="currency"
                    [inputStyle]="{ width: '100%' }"
                    (onFocus)="selectInputContent($event)"
                    formControlName="weight"
                    class="w-full"
                  />
                </div>
                <div>
                  <button class="ml-2 cursor-pointer px-3 py-2 rounded bg-orange-500 hover:bg-orange-600 text-white"><i class="pi pi-plus"></i></button>
                </div>
              </div>
            </div>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>

 <!-- Botões -->
    <div class="flex justify-end gap-3">
      <button (click)="goBack()" type="button" class="border px-2 border-orange-500 cursor-pointer rounded">Cancelar</button>
      <button
        type="submit"
        class="bg-[#fe6a00] px-4 py-2 cursor-pointer rounded border-[#fe6a00] hover:bg-[#e65c00] text-white"
      >
        {{ isEditMode ? 'Salvar' : 'Cadastrar' }}
      </button>
    </div>
  </form>
</div>


<app-modal
  [header]="'Nova Unidade'"
  [(visible)]="showUniteMeasureForm">
  <ng-container *ngIf="showUniteMeasureForm">
    <app-create-measure-of-unit (formSubmitted)="onModalSubmit('uniteMeasure')"></app-create-measure-of-unit>
  </ng-container>
</app-modal>

<app-modal
  [header]="'Novo Grupo'"
  [(visible)]="showGroupForm">
    <ng-container *ngIf="showGroupForm">
      <app-create-group (formSubmitted)="onModalSubmit('group')"></app-create-group>
    </ng-container>
</app-modal>

<app-modal [header]="'Novo Setor'" [(visible)]="showSectorForm">
  <ng-container *ngIf="showSectorForm">
    <app-create-sector (formSubmitted)="onModalSubmit('sector')"></app-create-sector>
  </ng-container>
</app-modal>

<app-modal
  [header]="'Nova Marca'" [(visible)]="showBrandForm">
  <ng-container *ngIf="showBrandForm">
    <app-create-brand (formSubmit)="onModalSubmit('brand')"></app-create-brand>
  </ng-container>
</app-modal>

<app-modal [header]="'Nova Família'" [(visible)]="showFamilyForm">
  <ng-container *ngIf="showFamilyForm">
    <app-create-family (formSubmitted)="onModalSubmit('family')"></app-create-family>
  </ng-container>
</app-modal>

<app-modal [header]="'Novo Subgrupo'" [(visible)]="showSubgroupForm">
  <ng-container *ngIf="showSubgroupForm">
    <app-create-subgroup
      [defaultGroupId]="form.get('groupId')?.value ?? null"
      (formSubmitted)="onModalSubmit('subgroup')"
    ></app-create-subgroup>
  </ng-container>
</app-modal>